import menu from "../Menu";
import group from "../Group";
import user from "../User";
import power from "../Power"
import role from "../Role"

/**
 *基础数据路由
 */
const Roles = [
    {
        name: '菜单管理',
        path: '/role/menu',
        component: menu
    },
    {
        name: '部门管理',
        path: '/role/group',
        component: group
    },
    {
        name: '用户管理',
        path: '/role/user',
        component: user
    },
    {
        name: '角色管理',
        path: '/role/role',
        component: role
    },
    {
        name: '权限管理',
        path: '/role/power',
        component: power
    },
];
export default Roles
